export class UpdatePaymentStatusModel {
    PaymentID: number;
    HeaderID: number;
    ToFinalDocuments: boolean;
}

export enum PaymentStatusCheckOutcome {
    Success = "success",
    Timeout = "timeout",
    Failed = "failed",
}

export enum SobitErrorCode {
    ERROR_BAD_REQUEST = -1,
    ERROR_TARGET_DEVICE_NOT_CONNECTED = 1,
    ERROR_SERVER_ERROR = 2,
    ERROR_TARGET_DEVICE_NOT_SET = 3,
    ERROR_WRONG_CREDENTIALS = 4,
    ERROR_WRONG_API_KEY = 5,
    ERROR_DUPLICATE_CONNECTION = 6,
    ERROR_TRANSACTION_NOT_FOUND = 7,

    SOBIT_LOAD_SCRIPT_START = 1001,
    SOBIT_LOAD_SCRIPT_SUCCESS = 1002,
    SOBIT_LOAD_SCRIPT_ERROR = 1003,
    SOBIT_GENERATE_CLIENT_START = 1004,
    SOBIT_GENERATE_CLIENT_MISSING_CONFIG = 1005,
    SOBIT_GENERATE_CLIENT_READY = 1006,
    SOBIT_PAY_BY_CARD_START = 1007,
    SOBIT_CLIENT_NOT_READY = 1008,
    SOBIT_PAY_BY_CARD_RESPONSE = 1009,
    SOBIT_UPDATE_PAYMENT_STATUS_FAILED = 1010,
    SOBIT_PAYMENT_ACCEPTED = 1011,
    SOBIT_PAYMENT_DECLINED = 1012,
    SOBIT_REGISTER_OFFLINE_PAYMENT_START = 1013,
    SOBIT_REGISTER_OFFLINE_PAYMENT_RESULT = 1014,
    SOBIT_UPDATE_PAYMENT_STATUS_START = 1015,
    SOBIT_UPDATE_PAYMENT_STATUS_REQUEST = 1016,
    SOBIT_UPDATE_PAYMENT_STATUS_RESPONSE = 1017,
    SOBIT_UPDATE_PAYMENT_STATUS_ERROR = 1018,
    SOBIT_CHECK_PAYMENTS_START = 1019,
    SOBIT_CHECK_PAYMENTS_FILTERED = 1020,
    SOBIT_CHECK_TRANSACTION_START = 1021,
    SOBIT_CHECK_TRANSACTION_RESPONSE = 1022,
    SOBIT_CHECK_TRANSACTION_ERROR = 1023,
    SOBIT_TRANSACTION_NOT_FOUND = 1024,
    SOBIT_WRONG_CREDENTIALS = 1025,
    SOBIT_UNSUPPORTED_CURRENCY = 1026,
    SOBIT_START_TRANSACTION_REQUEST = 1027,
    SOBIT_START_TRANSACTION_RESPONSE = 1028,
    SOBIT_START_TRANSACTION_CONNECTION = 1029,
    SOBIT_START_TRANSACTION_ERROR = 1030,
    SOBIT_CHECK_TRANSACTION_REQUEST = 1031,
    SOBIT_CONNECTION_STATUS = 1032,
    SOBIT_GET_CONFIG_START = 1033,
    SOBIT_GET_CONFIG_INVALID = 1034,
    SOBIT_GET_CONFIG_SUCCESS = 1035,
    SOBIT_GET_CONFIG_ERROR = 1036,
    SOBIT_PAY_BY_CARD_ERROR = 1037,
    SOBIT_TERMINAL_STATE_DIALOG_SHOWN = 1038,
    SOBIT_TERMINAL_STATE_DIALOG_CLOSED = 1039,
    SOBIT_CHECK_TRANSACTION_TIMEOUT = 1040,
    SOBIT_CHECK_PAYMENTS_COMPLETE = 1041,
}
